// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"markdown_shadow__1r1ti","markdown":"markdown_markdown__3mWfo"};